import axios from 'axios';
import store from '@/store';
import _ from 'lodash';

const apiPath = `${store.state.apiPathWithVersion}/profile`;

export default {
  async show(callback, errorCallback) {
    let apiUrl = store.state.countrySelected.api;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/show`);
      callback(resp.data);
    } catch (error) {
      errorCallback(error.data);
    }
  },
  async requestChangeUsername(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/requestChangeUsername?lang=${params.lang}`,
        params
      );

      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },
  async changeUsername(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/changeUsername?lang=${params.lang}`,
        params
      );

      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },
  async requestValidatePhone(params, callback, errorCallback) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/phone/activate?lang=${params.lang}`,
        params
      );
      callback(resp.data);
    } catch (error) {
      errorCallback(error.data);
    }
  },
  async requestChangePhone(params, callback, errorCallback) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      const data = new FormData();
      _.each(params, (value, key) => {
        data.append(key, value);
      });
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/phone/request?lang=${params.lang}`,
        data,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      callback(resp.data);
    } catch (error) {
      errorCallback(error.data);
    }
  },
  async changePassword(payload) {
    let apiUrl = store.state.countrySelected.api;
    payload.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/edit?lang=${payload.lang}`,
        payload
      );
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },
  async edit(payload) {
    let apiUrl = store.state.countrySelected.api;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/edit?lang=${payload.lang}`,
        payload
      );
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },
  async checkPhone(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/checkPhone`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },
  async updatePhone(payload) {
    let apiUrl = store.state.countrySelected.api;
    let lang = store.state.langSelected.langWsp;
    try {
      let resp = await axios.post(
        `${apiUrl}/${apiPath}/updatePhone?lang=${lang}`,
        payload
      );
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
